import { useState } from "react";
import Webcam from "react-webcam";
import flipCameraIcon from '../assets/flip-camera.png';
import './Camera.css'; // Import the CSS file for styling

const Camera = () => {
  const [facingMode, setFacingMode] = useState("environment"); // Start with back camera

  const toggleCamera = () => {
    setFacingMode(prevMode => 
      prevMode === "environment" ? "user" : "environment"
    );
  };

  const videoConstraints = {
    facingMode: facingMode,
    width: { ideal: 1280 },
    height: { ideal: 720 }
  };

  return (
    <div className="camera">
      <Webcam
        audio={false}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
        width="100%"
        height="auto"
      />
      <button 
        className="camera-switch"
        onClick={toggleCamera}
        aria-label="Switch Camera"
      >
        <img 
          src={flipCameraIcon} 
          alt="Switch Camera" 
          className="flip-camera-icon"
        />
      </button>
    </div>
  );
};

export default Camera;